/**
 * Bing Webmaster Tools integration API client.
 *
 * Backed by /api/intel/bwt/* on the backend. Mirror of gscRequests.js.
 * Unlike GSC, the import pulls INBOUND LINKS (backlinks), not keywords —
 * so it grounds seo.referring_domains and fills "Our backlinks".
 */

import { getClient } from './base/api';

const client = getClient();

// ---------------- OAuth ----------------

/** Returns { url, redirect_uri, scopes_requested }; SPA opens url in a popup. */
export const getBwtAuthUrl = async (opts = {}) => {
  const params = {};
  if (opts.redirect_uri) params.redirect_uri = opts.redirect_uri;
  return client.get('intel/bwt/auth-url', { params });
};

/** Exchange the code the popup received from Bing. Called by the popup. */
export const completeBwtOauth = async ({ code, state, redirect_uri }) => {
  return client.post('intel/bwt/callback', {
    code, state, redirect_uri: redirect_uri || undefined,
  });
};

// ---------------- Connection ----------------

export const getBwtStatus = async () =>
  client.get('intel/bwt/status');

export const listBwtSites = async () =>
  client.get('intel/bwt/sites');

export const setBwtSite = async (siteUrl) =>
  client.post('intel/bwt/site', { site_url: siteUrl });

export const disconnectBwt = async () =>
  client.delete('intel/bwt/connection');

// ---------------- Import / preview ----------------

export const previewBwtImport = async ({ max_pages = 5 } = {}) =>
  client.get('intel/bwt/preview', { params: { max_pages } });

export const importBwtBacklinks = async ({ max_pages = 20 } = {}) =>
  client.post('intel/bwt/import', { max_pages });

const bwtApi = {
  getBwtAuthUrl, completeBwtOauth,
  getBwtStatus, listBwtSites, setBwtSite, disconnectBwt,
  previewBwtImport, importBwtBacklinks,
};

export default bwtApi;
